'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { createRef, PureComponent } from 'react';
import PropTypes from 'prop-types';
import CjkCharacterRegExp from 'I18n/constants/regex/CJK';
import text from 'I18n/utils/unescapedText';
import UISearchInput from 'UIComponents/input/UISearchInput';
import withKeyboardShortcuts from 'DesignComponents/decorators/withKeyboardShortcuts';

const i18nKey = key => `DesignFinderUI.search.SearchInput.${key}`;

const INPUT_TIMEOUT = 500;

class SearchInput extends PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = evt => {
      const {
        value: searchTerm
      } = evt.target;
      this.setState({
        searchTerm
      });
    };

    this.handleKeyDown = () => {
      this.clearInputTimeout();
    };

    this.handleKeyUp = () => {
      this.clearInputTimeout();
      this.__inputTimeout = window.setTimeout(() => {
        const {
          minimumSearchCount,
          onSearchChange
        } = this.props;
        const {
          searchTerm
        } = this.state;

        if (searchTerm && searchTerm.length >= minimumSearchCount) {
          onSearchChange(searchTerm);
        }
      }, INPUT_TIMEOUT);
    };

    this.clearInputTimeout = () => {
      if (this.__inputTimeout) {
        window.clearTimeout(this.__inputTimeout);
      }
    };

    this.focus = () => {
      if (this.__inputRef.current) {
        this.__inputRef.current.focus();
      }
    };

    this.renderValidationMessage = searchQuery => {
      const {
        minimumSearchCount
      } = this.props;

      if (searchQuery && searchQuery.length && searchQuery.length < minimumSearchCount && !CjkCharacterRegExp.test(searchQuery)) {
        return text(i18nKey('minimumSearchMessage'), {
          count: minimumSearchCount - searchQuery.length
        });
      }

      return null;
    };

    this.state = {
      searchTerm: props.initialSearchTerm
    };
    this.__inputRef = /*#__PURE__*/createRef();
  }

  componentDidUpdate(prevProps) {
    const {
      onSearchChange,
      isFocusRequested,
      initialSearchTerm: nextSearchTerm
    } = this.props;
    const {
      searchTerm
    } = this.state;

    if (nextSearchTerm !== prevProps.initialSearchTerm) {
      this.setState({
        searchTerm: nextSearchTerm
      });
    }

    if (!searchTerm) {
      this.clearInputTimeout();
      onSearchChange(null);
    }

    if (isFocusRequested) {
      this.focus();
    }
  }

  render() {
    const {
      disabled
    } = this.props;
    const {
      searchTerm
    } = this.state;
    const placeholderText = text(i18nKey('placeholder'));
    return /*#__PURE__*/_jsx(UISearchInput, {
      disabled: disabled,
      getValidationMessage: this.renderValidationMessage,
      onChange: this.handleChange,
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp,
      placeholder: placeholderText,
      value: searchTerm || '',
      inputRef: this.__inputRef
    });
  }

}

SearchInput.propTypes = {
  disabled: PropTypes.bool,
  initialSearchTerm: PropTypes.string,
  minimumSearchCount: PropTypes.number,
  onSearchChange: PropTypes.func.isRequired,
  isFocusRequested: PropTypes.bool
};
SearchInput.defaultProps = {
  disabled: false,
  initialSearchTerm: '',
  minimumSearchCount: 0
};
export default withKeyboardShortcuts()(SearchInput);